import { useParams, Outlet } from 'react-router-dom';
import ClientProvider from 'context/ClientContextProvider';

const ClientWrapper = () => {
  const { clientId } = useParams();

  return (
    <ClientProvider clientId={clientId}>
      <Outlet />
    </ClientProvider>
  );
};

export default ClientWrapper;
